module.exports = __webpack_public_path__ + "static/media/contact_location.34c23bc4.svg";